import BMGLogo from './media/logo-bmg.svg';
import Channel4Logo from './media/logo-channel4.svg';
import DeepMindLogo from './media/logo-deepmind.svg';
import GoogleLogo from './media/logo-google-health.svg';
import NokiaLogo from './media/logo-nokia.svg';
import PhaidraLogo from './media/logo-phaidra.svg';
import SymbianLogo from './media/logo-symbian.svg';
import SynthesiaLogo from './media/logo-synthesia.svg';

import classNames from './styles.module.css';
import { Company } from '../../../../types';
import { useEffect, useRef } from 'react';

interface BoxProps {
  company: Company;
  fadeInDelay?: number;
  isEven?: boolean;
  onNavigate: (id: string) => void;
}

const LOGOS: { [key: string]: string } = {
  bmg: BMGLogo,
  channel4: Channel4Logo,
  deepmind: DeepMindLogo,
  'google-health': GoogleLogo,
  nokia: NokiaLogo,
  phaidra: PhaidraLogo,
  symbian: SymbianLogo,
  synthesia: SynthesiaLogo,
};

export const Box = ({ company, fadeInDelay = 0, isEven = false, onNavigate }: BoxProps) => {
  const handleClick = () => {
    document.location.hash = company.id;
    onNavigate(company.url);
  };

  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const buttonEl = buttonRef.current;
    if (!buttonEl || buttonEl.classList.contains(classNames.show)) {
      return;
    }

    setTimeout(() => {
      buttonEl.classList.add(classNames.show);
    }, fadeInDelay);
  }, []);

  return (
    <button
      ref={buttonRef}
      className={`${classNames.box} ${isEven ? classNames.blue : ''}`}
      onClick={handleClick}
      aria-label={`View ${company.name} work`}
    >
      <img
        src={LOGOS[company.id]}
        className={classNames.boxLogo}
        alt={`${company.name} logo`}
        width={160}
        height={48}
      />
    </button>
  );
};
